import React from 'react';

const GuideImage = ({ className }: { className: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      className={className}
    >
      <path
        d="M41.8555 20.1183L32.4389 10.794C31.1468 9.51694 29.0795 9.47639 27.8288 10.7129C27.5083 11.0271 27.2809 11.3919 27.1259 11.7872C25.8338 10.6419 23.8699 10.6419 22.6708 11.8277C22.3194 12.1723 22.0817 12.5879 21.9369 13.0338C20.6862 12.3345 19.0944 12.4663 18.0711 13.4899C16.8307 14.7163 16.8617 16.7534 18.1434 18.0304L15.1768 15.1014C15.1252 15.0406 15.0528 15.0102 15.0011 14.9595C11.3937 11.7467 7.22805 11.7365 7.22805 11.7365C6.31843 11.6453 5.38814 11.9088 4.70593 12.5777C3.5069 13.7636 3.5379 15.7298 4.78863 16.9663C5.26411 17.4426 5.85329 17.7365 6.46314 17.848C9.20233 18.1622 10.9492 19.875 10.9492 19.875L15.8797 24.75C12.8098 28.5811 16.624 31.7737 16.624 31.7737L20.893 36C20.893 36 22.9396 38.4426 26.6607 38.169H35.7879L45.0391 29.0169C45.9177 23.6757 41.8451 20.1183 41.8451 20.1183H41.8555Z"
        fill="white"
      />
      <path
        d="M15.8796 24.75C12.8096 28.5811 16.6238 31.7736 16.6238 31.7736L20.8928 36C20.8928 36 22.9394 38.4426 26.6606 38.1689H35.7878"
        stroke="#212121"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.049 29.0169C45.9276 23.6757 41.855 20.1183 41.855 20.1183L32.4385 10.794C31.1464 9.51694 29.0791 9.47639 27.8284 10.7129C27.5079 11.0271 27.2805 11.3919 27.1255 11.7872C25.8334 10.6419 23.8695 10.6419 22.6704 11.8277C22.319 12.1723 22.0812 12.5879 21.9365 13.0338C20.6858 12.3345 19.094 12.4663 18.0707 13.4899C16.8303 14.7163 16.8613 16.7737 18.1534 18.0507L15.1661 15.1014C15.1144 15.0507 15.0421 15.0102 14.9904 14.9595C11.3829 11.7467 7.21731 11.7365 7.21731 11.7365C6.30769 11.6453 5.3774 11.9088 4.69519 12.5777C3.49615 13.7636 3.52716 15.7298 4.77788 16.9663C5.25336 17.4426 5.84255 17.7365 6.4524 17.848C9.19159 18.1622 10.9385 19.875 10.9385 19.875L20.0553 28.8953"
        stroke="#212121"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1533 18.0405L20.8925 20.7466"
        stroke="#212121"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9365 13.0338L25.3166 16.3683"
        stroke="#212121"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.1357 11.7871L29.6268 14.2499"
        stroke="#212121"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GuideImage;
